import styled from "styled-components"
import { Button, Modal, OutlineButton } from "~/components"
import { useTranslate } from "~/ur-react-hooks"

const Layout = styled.div`
  display: flex;
  flex-direction: column;

  background: white;
  box-shadow: ${(props) => props.theme.shadow.elevation3};
  padding: 2rem;
  width: 456px;
  border-radius: 8px;
`

const Title = styled.h4`
  font-size: 18px;
  margin: 0;
`

const Description = styled.p``

const Buttons = styled.div`
  margin-top: 1rem;
  display: flex;
  justify-content: space-between;

  gap: 1rem;

  button {
    flex: 1;
  }
`

export interface WillCancelPromptProps {
  isOpen: boolean
  onClose: (value: boolean) => void
}

const WillCancelPrompt: React.FC<WillCancelPromptProps> = ({
  isOpen,
  onClose,
}) => {
  const translations = useTranslate({
    title: "subscription-will-cancel.modal.title",
    reactivate: "subscription-personal.reactivate",
    reactivateConfirm: "subscription-personal.reactivate-confirm",
    yes: "common.yes",
    no: "common.no",
  })
  return (
    <Modal open={isOpen} onClose={() => onClose(false)}>
      <Layout>
        <Title>{translations.title}</Title>
        <Description>{translations.reactivateConfirm}</Description>
        <Buttons>
          <Button onClick={() => onClose(true)}>{translations.yes}</Button>
          <OutlineButton onClick={() => onClose(false)}>
            {translations.no}
          </OutlineButton>
        </Buttons>
      </Layout>
    </Modal>
  )
}

export default WillCancelPrompt
